import { connect } from 'react-redux';
import MiniWishlistSummary from './miniWishlistSummary';

const mapStateToProps = ({ miniWishlist }) => ({
  totalItems: miniWishlist.totalItems,
});

export default connect(mapStateToProps)(MiniWishlistSummary);
